import store from '../../../index'
import { get, isArray, isNull, isPlainObject, isUndefined } from 'lodash'
import { getDeviceLocation } from '../../../../services/nativescript.service'
import { FIELD_TYPES } from './constants'
import Vue from 'vue'
import { ERROR_MSG_TYPE } from '../../../../utils'
import MainForm from './MainForm'
import SubForm from './SubForm'
import axios from '../../../../axiosClient'

const isEnvProduction = process.env.NODE_ENV === 'production'
const LAT_LON_SEPARATOR = ';'

export default class ExpressionResolver {
  /**
   * @description Kifejezesek kiertekelese futasidoben
   * @param fieldState
   * @param expression
   * @param namespace
   * @param sfRowIndex
   * @param triggerName
   * @return {Promise<*>}
   */
  static async resolve({ fieldState, expression, namespace, sfRowIndex = null, triggerName }) {
    let _result = get(fieldState, 'value')
    const Queries = get(store, 'state.Queries', {})
    const lodash = require('lodash')
    const logger = console

    async function query(queryName, params = [], path = null) {
      if (!isArray(params)) {
        params = [params]
      }
      const res = await Queries[queryName](...params)
      return path ? get(res, path.trim()) : res
    }

    async function relatedField(fieldName, fieldProperties) {
      const fieldGetter = get(store, `getters[${namespace}/expressionFieldByPath]`)
      const fieldPathMap = get(store, `getters[${namespace}/fieldPathMap]`, {})
      let fieldPath = fieldPathMap[fieldName]
      fieldPath = fieldPath.replace('rowId', sfRowIndex)
      const field = fieldGetter(fieldPath)
      const type = get(field, 'type')
      const isMultiselect = get(field, 'multiselect')
      if (
        (type === FIELD_TYPES.DROPDOWN || type === FIELD_TYPES.SQL_CHOSEN) &&
        !isMultiselect &&
        isArray(fieldProperties)
      ) {
        const tableName = get(field, 'typeOptions.table')
        const relField = get(field, 'typeOptions.valueColumn')
        const relId = get(field, 'value')
        const params = { tableName, relField, relId, fieldProperties }
        const relatedField = await axios().get('/api/Dynforms/get-related-field', { params })
        return get(relatedField, 'data')
      }
      return null
    }

    function mainForm() {
      const fieldGetter = get(store, `getters[${namespace}/expressionFieldByPath]`)
      const fieldPathMap = get(store, `getters[${namespace}/fieldPathMapByFormName]`, {})

      return new MainForm(fieldGetter, fieldPathMap)
    }

    function subForm(subFormName) {
      const fieldGetter = get(store, `getters[${namespace}/expressionFieldByPath]`)
      const fieldPathMap = get(store, `getters[${namespace}/fieldPathMap]`, {})

      return new SubForm(fieldGetter, fieldPathMap, subFormName)
    }

    function field(fieldName, path = 'value', index = null) {
      const fieldGetter = get(store, `getters[${namespace}/expressionFieldByPath]`)
      const fieldPathMap = get(store, `getters[${namespace}/fieldPathMap]`, {})
      let fieldPath = fieldPathMap[fieldName]

      if (fieldPath) {
        fieldPath = fieldPath.replace('rowId', sfRowIndex)
      } else {
        fieldPath = fieldName
      }

      const field = fieldGetter(fieldPath)
      let value

      if (field.hasOwnProperty('subForm')) {
        value = get(field, 'subForm.rows', null)
      } else {
        value = get(field, path, null)
      }

      if (isArray(value) && !isNull(index)) {
        return value[index]
      }

      return value
    }

    function result(res) {
      _result = res
      return _result
    }

    function getResult() {
      return _result
    }

    function param(path) {
      return get(window.CORE.params, path)
    }

    function doto(path) {
      return get(window.CORE, path)
    }

    function core(path) {
      return get(window.CORE, path)
    }

    function userFunctions(fnName, params) {
      if (!isArray(params)) {
        params = [params]
      }
      return window.UserDefined[fnName](...params)
    }

    async function concat() {
      return await Promise.all(arguments).then((results) => results.join(''))
    }

    function location() {
      return getDeviceLocation().then((data) => {
        let coordinates = ''
        if (!data.latitude || !data.longitude) return coordinates
        coordinates = `${data.latitude}${LAT_LON_SEPARATOR}${data.longitude}`

        axios({ method: 'post' }).then((instance) => instance.post('/api/Gps/set-location', { coordinates }))
        return coordinates
      })
    }

    /**
     * @description axios proxy
     * @param url
     * @param method
     * @param headers
     * @param data
     * @returns {*}
     */
    function callApi({ url, method = 'get', headers = {}, data }) {
      if (method === 'get') {
        const serialized = Object.entries(data).reduce((params, [key, value]) => {
          params[key] = isPlainObject(value) ? JSON.stringify(value) : value
          return params
        }, {})
        const params = new URLSearchParams(serialized)
        return axios().get(`${url}?${params.toString()}`, { headers })
      }
      return axios({ url, method, headers, data })
    }

    let res
    try {
      res = await eval(expression)
    } catch (error) {
      if (!isEnvProduction) {
        console.error(`error in expression evaluation: `, {
          expression,
          error: error,
        })
        const localizedMessage = Vue.prototype.$i18n.interpolate(Vue.prototype.$i18n.t('field_name: ${fieldName}. '), {
          fieldName: get(fieldState, 'name'),
        })
        const errorMessage = error.message
        Vue.prototype.$notify({
          title: Vue.prototype.$i18n.t('error_in_expression'),
          message: localizedMessage + errorMessage,
          type: ERROR_MSG_TYPE.ERROR,
        })
      }
    }

    return isUndefined(res) ? _result : res
  }
}
